import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { format } from '@dt/fe-utils'
import { CardShape } from 'pages/mkt/components'
import mktController from 'controllers/mktController'
import './index.scss'

interface IProps {
  recordInfo: any;
  onClick?: (e?: any) => void;
}
interface IState {
  showCode: boolean;
}

const GiftRecordItem: FC<IProps> = (props) => {
  const {
    recordInfo,
    onClick
  } = props
  const giftCardStatus = {
    bind: i18n.t('mkt.giftCard.boundAfterTransfer'),
    unbind: i18n.t('mkt.giftCard.unboundAfterTransfer'),
    cancel: i18n.t('mkt.giftCard.cancleSend')
  }

  return (
    <div className='gift-record-item' onClick={onClick}>
      <div className='header'>
        <span>{format.toDateTime(recordInfo.addTime)}</span>
        <span className={`status ${recordInfo.status === 'unbind' ? 'unbind' : ''}`}>{giftCardStatus[recordInfo.status]}</span>
      </div>
      <div className='content'>
        <div className={`content-l${!recordInfo.giveMemberCard?.extra?.shape || recordInfo.giveMemberCard.extra.shape === 'rectangle' ? ' rectangle' : ''}`}>
          <CardShape shape={recordInfo.giveMemberCard?.extra?.shape || 'rectangle'} cardFace={mktController.getGiveGifCardCover(recordInfo)} border='border' isScale={false}></CardShape>
        </div>
        <div className='content-r'>
          <span>{recordInfo.giftcard.giftcardName}</span>
        </div>
      </div>
    </div>
  )
}

export default observer(GiftRecordItem)
